
function ItemCard1({ text, date }) {
    return (
      <div className="itemcard p-3">
        <h6 className="mb-0 fw-bold text-white">{text}</h6>
        <h6 className="mb-0 fw-bold text-secondary">{date}</h6>
      </div>
    )
  }
  
  export default ItemCard1